import { useEffect } from 'react';

export function useScrollLock(lock: boolean) {
  const originalStyle = window.getComputedStyle(document.body).overflow;
  useEffect(() => {
    if (lock) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, [lock]);
}
